import React from 'react'

const Footer = () => {
  return (
    <div className='flex flex-col font-[popins] items-center justify-center bg-gradient-to-r from-violet-500 to-blue-500 md:h-[34rem] h-80 border-dashed border-2 border-t-0 border-r-0 border-b-8 border-l-0 border-white'>
              
            </div>
  )
}

export default Footer